import { UserPermissions } from "Infrastructure/Api/permissions";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { moduleTranslation } from "Settings/User/Components/Form/Utils/moduleNameTranslation";
import { FormCheckboxMultiple } from "Shared/Components/Form/CustomFormComponent/FormCheckboxMultiple";
import CustomCheckbox from "Shared/Components/Inputs/CustomCheckbox";
import { Grid2, Stack, Typography } from "@mui/material";

const userResource = Resources.base.user.roles;

const PermissionsSection = ({ form }) => {
	const { t } = useResource();
	const { setValue, control, watch } = form;

	const selectedPermissions = watch("permissions") || [];

	const handleSelectAll = (permissions: string[]) => {
		const allSelected = permissions.every((perm) =>
			selectedPermissions.includes(perm),
		);
		const updatedPermissions = allSelected
			? selectedPermissions.filter(
					(perm: string) => !permissions.includes(perm),
				)
			: [...new Set([...selectedPermissions, ...permissions])];

		setValue("permissions", updatedPermissions);
	};

	const handleCheckboxChange = (value: string) => {
		const updatedPermissions = selectedPermissions.includes(value)
			? selectedPermissions.filter((perm) => perm !== value)
			: [...selectedPermissions, value];

		setValue("permissions", updatedPermissions);
	};

	return (
		<Grid2 container spacing={2}>
			{Object.entries(UserPermissions).map(([module, permissions]) => {
				const permissionValues = Object.values(permissions);
				const allSelected = permissionValues.every((perm) =>
					selectedPermissions.includes(perm),
				);
				return (
					<Grid2 size={{ xs: 12 }} key={module}>
						<Typography variant="h6">
							{t(userResource[moduleTranslation(module)])}
						</Typography>

						<Grid2 container spacing={2} mt={1}>
							<Grid2 size={{ xs: 12 }}>
								<Stack flexDirection="row" alignItems="center">
									<CustomCheckbox
										name="selectAll"
										checked={allSelected}
										onChange={() => handleSelectAll(permissionValues)}
									/>
									<Typography variant="body1" color="primary" sx={{ ml: 1 }}>
										{t(userResource.selectAll)}
									</Typography>
								</Stack>
							</Grid2>

							{Object.entries(permissions).map(([key, value]) => (
								<Grid2 size={{ xs: 6 }} key={value}>
									<FormCheckboxMultiple
										label={key}
										name="permissions"
										control={control}
										checked={selectedPermissions.includes(value)}
										onChange={() => handleCheckboxChange(value)}
									/>
								</Grid2>
							))}
						</Grid2>
					</Grid2>
				);
			})}
		</Grid2>
	);
};

export default PermissionsSection;
